export const segment = [
  'FIRST_HOME',
  'SUBSIDY',
  'INVESTMENT',
  'COMPLEMENTARY',
  'NEW_MORTGAGE',
  'HOME_EQUITY'
];

export const subSegment = [
  'INVESTMENT_1',
  'INVESTMENT_2',
  'FIRST_HOME_1',
  'FIRST_HOME_2',
  'FIRST_HOME_3',
  'FIRST_HOME_4',
  'FIRST_HOME_5',
  'FIRST_HOME_6',
  'FIRST_HOME_7',
  'SUBSIDY_1_1',
  'SUBSIDY_1_2',
  'SUBSIDY_2_1',
  'SUBSIDY_2_2',
  'COMPLEMENTARY_1',
  'NEW_MORTGAGE_1',
  'NEW_MORTGAGE_2',
  'YOUNG_PROFESSIONAL_1',
  'YOUNG_PROFESSIONAL_2',
  'YOUNG_PROFESSIONAL_3',
  'FULLY_FORMAL_1',
  'FULLY_FORMAL_2',
  'FULLY_FORMAL_3',
  'INDEPENDENT_1',
  'INDEPENDENT_2',
  'INDEPENDENT_3',
  'SUBSIDY_1',
  'HOME_EQUITY_1_EQUITY_FRENCH_GRACE_MONTHS_12_CREDIT_INSURANCE_FINANCING_0_6',
  'HOME_EQUITY_2_EQUITY_GERMAN_GRACE_MONTHS_12_CREDIT_INSURANCE_FINANCING_0_6',
  'HOME_EQUITY_3_EQUITY_FRENCH_GRACE_MONTHS_12_CREDIT_INSURANCE_FINANCING_0',
  'HOME_EQUITY_4_EQUITY_GERMAN_GRACE_MONTHS_12_CREDIT_INSURANCE_FINANCING_0',
  'HOME_EQUITY_5_EQUITY_FRENCH_GRACE_MONTHS_0_CREDIT_INSURANCE_FINANCING_1',
  'HOME_EQUITY_6_EQUITY_GERMAN_GRACE_MONTHS_0_CREDIT_INSURANCE_FINANCING_1',
  'FIRST_HOME_1_FULLY_FRENCH_GRACE_MONTHS_12_CREDIT_INSURANCE_FINANCING_0_55',
  'FIRST_HOME_2_FULLY_GERMAN_GRACE_MONTHS_12_CREDIT_INSURANCE_FINANCING_0_55',
  'FIRST_HOME_3_FULLY_FRENCH_GRACE_MONTHS_12_CREDIT_INSURANCE_FINANCING_0',
  'FIRST_HOME_4_FULLY_GERMAN_GRACE_MONTHS_12_CREDIT_INSURANCE_FINANCING_0',
  'FIRST_HOME_5_FULLY_FRENCH_GRACE_MONTHS_0_CREDIT_INSURANCE_FINANCING_1',
  'FIRST_HOME_6_FULLY_GERMAN_GRACE_MONTHS_0_CREDIT_INSURANCE_FINANCING_1',
  'FIRST_HOME_7_INFORMAL_FRENCH_GRACE_MONTHS_12_CREDIT_INSURANCE_FINANCING_0_55',
  'FIRST_HOME_8_INFORMAL_GERMAN_GRACE_MONTHS_12_CREDIT_INSURANCE_FINANCING_0_55',
  'FIRST_HOME_9_INFORMAL_FRENCH_GRACE_MONTHS_12_CREDIT_INSURANCE_FINANCING_0',
  'FIRST_HOME_10_INFORMAL_GERMAN_GRACE_MONTHS_12_CREDIT_INSURANCE_FINANCING_0',
  'FIRST_HOME_11_INFORMAL_FRENCH_GRACE_MONTHS_0_CREDIT_INSURANCE_FINANCING_1',
  'FIRST_HOME_12_INFORMAL_GERMAN_GRACE_MONTHS_0_CREDIT_INSURANCE_FINANCING_1',
  'INVESTMENT_1_INVEST_FRENCH_GRACE_MONTHS_12_CREDIT_INSURANCE_FINANCING_0_55',
  'INVESTMENT_2_INVEST_GERMAN_GRACE_MONTHS_12_CREDIT_INSURANCE_FINANCING_0_55',
  'INVESTMENT_3_INVEST_FRENCH_GRACE_MONTHS_12_CREDIT_INSURANCE_FINANCING_0',
  'INVESTMENT_4_INVEST_GERMAN_GRACE_MONTHS_12_CREDIT_INSURANCE_FINANCING_0',
  'INVESTMENT_5_INVEST_FRENCH_GRACE_MONTHS_0_CREDIT_INSURANCE_FINANCING_1',
  'INVESTMENT_6_INVEST_GERMAN_GRACE_MONTHS_0_CREDIT_INSURANCE_FINANCING_1',
  'FIRST_HOME_1_YOUNG_FRENCH_GRACE_MONTHS_12_CREDIT_INSURANCE_FINANCING_0',
  'FIRST_HOME_2_YOUNG_GERMAN_GRACE_MONTHS_12_CREDIT_INSURANCE_FINANCING_0',
  'FIRST_HOME_3_YOUNG_FRENCH_GRACE_MONTHS_0_CREDIT_INSURANCE_FINANCING_1',
  'FIRST_HOME_4_YOUNG_GERMAN_GRACE_MONTHS_0_CREDIT_INSURANCE_FINANCING_1'
];

export const purpose = [
  'HOME',
  'INVEST'
];

export const amortizationMethod = [
  'FRENCH',
  'GERMAN'
];

export const interestType = [
  'COMPOUND',
  'SIMPLE'
];

export const graceMonthsInterestMethod = [
  'NOT_POSTPONED',
  'POSTPONED'
];

export const operationalExpensesInterest = [
  'WITH_INTEREST',
  'NO_INTEREST'
];

export const lifeInsuranceTypeOfPremium = [
  'MULTIPLE'
];
export const creditInsuranceFeeTermDefinition = [
  'SHORT',
  'LONG'
];
